import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNrday75 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_75: Record<
  Exclude<PageIdWoofzNrday75, PageIdWoofzNrday75.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NRDAY_75_N]: {
    id: PageId.SUBSCRIPTIONS_NRDAY_75_N,
  },
  [PageId.CHAT_UPSELL_NRDAY_75]: {
    id: PageId.CHAT_UPSELL_NRDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NRDAY_75]: {
    id: PageId.UPSELL_NRDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NRDAY_75]: {
    id: PageId.DOWNLOAD_NRDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
